import { branch, renderNothing } from 'recompose'
import CaseSummaryContainer from './CaseSummaryContainer'
// eslint-disable-next-line
const enhance = branch((props) => !props.case, renderNothing)
export default enhance(CaseSummaryContainer)
